module.exports = "fragment InviteFragment on Invite {\n  id\n  createdAt\n}\n"